<template>
  <div class="ProgressBar">
    <div class="containment">
      <div class="text">
        {{ localeStrings.progress }} {{ percentage }}
      </div>
      <div class="track">
        <div class="fill" :style="{ width: percentage }" />
      </div>
    </div>
  </div>
</template>

<script>
import strings from '../data/strings.json'
export default {
  inject: ['locale'],
  props: {
    progress: {
      type: Number,
      required: true,
    },
  },
  computed: {
    localeStrings() {
      return strings[this.locale]
    },
    percentage() {
      return `${Math.round(100 * this.progress)}%`
    },
  },
}
</script>

<style scoped>
.ProgressBar {
  background-color: var(--brand-color);
  display: flex;
  padding-left: var(--wizard-gutter-width-left);
  padding-right: var(--wizard-gutter-width-right);
  padding-top: var(--spacing-8);
  padding-bottom: var(--spacing-8);
}
.containment {
  display: flex;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  max-width: 42rem;
}
.track, .fill {
  border-radius: 999px;
  height: 12px;
}
.track {
  background-color: white;
  margin-left: var(--spacing-5);
  flex-grow: 1;
}
.fill {
  background-color: var(--text-color-black);
  transition: width 0.5s;
}
.text {
  font-weight: 500;
  font-size: var(--font-size-1);
  color: white;
}

@media (--screen-lg) {

  .ProgressBar {
    background-color: white;
  }

  .track {
    background-color: #F0F0F3;
  }

  .fill {
    background-color: var(--brand-color);
  }

  .text {
    color: #575757;
  }
}
</style>
